import React from "react"
import { Dialog, FlatButton, TextField } from "material-ui"
import strings from "../../../localization/strings"
import * as utils from "../../../helpers/utils"

interface IProps {
    dayInfo: string
    handleClose(): void
    handleDelay(delayLength: number, delayNote: string): void
}
interface IState {
    delayLength: number
    errorDelayLength: string
    note: string
    errorNote: string
}

export default class DelayDayDialog extends React.Component<IProps, IState> {
    constructor(props) {
        super(props)
        this.state = {
            delayLength: 0,
            errorDelayLength: "",
            note: "",
            errorNote: ""
        }
    }

    checkValidate() {
        let isValidate = true
        if (this.state.delayLength > 0) {
            if (utils.validateInteger(this.state.delayLength)) {
                this.setState({ errorDelayLength: "" })
            }
            else {
                this.setState({ errorDelayLength: strings.Input_valid_integer })
                isValidate = false
            }
        }
        else {
            this.setState({ errorDelayLength: strings.formatString(strings.This_field_must_be_greater_than_x, 0) as string })
            isValidate = false
        }

        if (this.state.note.trim()) {
            this.setState({ errorNote: "" })
        }
        else {
            this.setState({ errorNote: strings.This_field_is_required })
            isValidate = false
        }

        return isValidate
    }

    handleSave() {
        if (!this.checkValidate())
            return
        this.props.handleDelay(this.state.delayLength, this.state.note)
    }

    render() {
        return (
            <Dialog
                id="DealyDayDialog"
                open
                title={strings.formatString(strings.x_Schedule_Delay, this.props.dayInfo) as string}
                titleStyle={{ paddingLeft: 35, paddingBottom: 10 }}
                actions={[
                    <FlatButton
                        data-intercom-target={"DealyDayDialog-Btn-Close"}
                        label={strings.CANCEL}
                        secondary={true}
                        onClick={this.props.handleClose}
                    />,
                    <FlatButton
                        data-intercom-target={"DealyDayDialog-Btn-Save"}
                        label={strings.SAVE}
                        primary={true}
                        onClick={() => this.handleSave()}
                    />
                ]}
            >
                <hr />
                <div style={{ paddingLeft: 30, paddingRight: 30 }}>
                    <div style={{ display: "flex", alignItems: "baseline" }}>
                        <div style={{ marginRight: 20, position: "relative" }}>
                            {strings.Enter_the_number_of_days_to_delay_the_schedule}
                            {this.state.errorDelayLength &&
                                <div style={{ fontSize: 12, color: "red" }}>
                                    {this.state.errorDelayLength}
                                </div>
                            }
                        </div>
                        <TextField
                            data-intercom-target={"DealyDayDialog-DelayLength"}
                            floatingLabelText={strings.Days}
                            value={this.state.delayLength}
                            onChange={(e, delayLength) => this.setState({ delayLength }, () => this.checkValidate())}
                            style={{ width: 50 }}
                            type="number"
                        />
                    </div>
                    <div>
                        <TextField
                            data-intercom-target={"DealyDayDialog-DelayNote"}
                            floatingLabelText={strings.Note}
                            value={this.state.note}
                            onChange={(e, note) => this.setState({ note }, () => this.checkValidate())}
                            errorText={this.state.errorNote}
                            errorStyle={{ position: "absolute", bottom: -10 }}
                            style={{ width: "100%" }}
                        />
                    </div>
                </div>
            </Dialog>
        )
    }
}